import { queryOptions } from "@tanstack/react-query";

import { fetchMe, MIN_PASSWORD_CHARS } from "@/lib/api";

/** The session as a query; `null` when nobody is logged in. */
export const meQuery = queryOptions({ queryKey: ["me"], queryFn: fetchMe, staleTime: 60_000 });

/**
 * Target after the login: only paths of this app, so a crafted link cannot
 * send the user to another site.
 */
export function safeRedirect(target: unknown): string {
  return typeof target === "string" && target.startsWith("/") && !target.startsWith("//")
    ? target
    : "/";
}

/** Check before sending a new password; `null` if fine. */
export function passwordProblem(password: string, repeat: string): string | null {
  if ([...password].length < MIN_PASSWORD_CHARS) {
    return `Das Passwort muss mindestens ${MIN_PASSWORD_CHARS} Zeichen lang sein.`;
  }
  if (password !== repeat) return "Die beiden Passwörter stimmen nicht überein.";
  return null;
}
